<template>
  <!-- Content -->
  <header id="global-header" data-unfolded="false" class="animated slideInDown affix">
    <a @click="$router.push('/')" class="heidian-logo pull-left" href="javascript:;"></a>
    <nav class="navbar collapse navbar-collapse header-nav pull-left" id="global-header-navbar-collapse">
      <ul class="nav navbar-nav navbar-left">
        <ul class="nav navbar-nav navbar-right">
          <li>联系我们</li>
          <li>客服电话: 18817744333</li>
          <li>邮箱: 18817744333@139.com</li>
          <li>
            <a class="get-trial" style="cursor: pointer" target="_blank">在线咨询</a>
          </li>
        </ul>
      </ul>
    </nav>
  </header>
</template>

<script>
export default {
  name: "Header",
  mounted() {
  },
  methods: {

  }
}
</script>

<style scoped>
.navbar-right{
  display: flex;
  align-items: center;
  gap:20px;
}
</style>
